module.exports = __webpack_public_path__ + "img/404.224a5c61.png";